/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S3_Li1Inputs */

const en_guide_large_json_files_s3_li1 = /** @type {(inputs: Guide_Large_Json_Files_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>JavaScript/Node.js</strong>: Use <code>JSONStream</code> or <code>stream-json</code> packages for streaming parse`)
};

const ko_guide_large_json_files_s3_li1 = /** @type {(inputs: Guide_Large_Json_Files_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>JavaScript/Node.js</strong>: 스트리밍 파싱을 위해 <code>JSONStream</code> 또는 <code>stream-json</code> 패키지 사용`)
};

const ja_guide_large_json_files_s3_li1 = /** @type {(inputs: Guide_Large_Json_Files_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>JavaScript/Node.js</strong>: ストリーミングパースに<code>JSONStream</code>や<code>stream-json</code>パッケージを使用`)
};

/**
* | output |
* | --- |
* | "<strong>JavaScript/Node.js</strong>: Use <code>JSONStream</code> or <code>stream-json</code> packages for streaming parse" |
*
* @param {Guide_Large_Json_Files_S3_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s3_li1 = /** @type {((inputs?: Guide_Large_Json_Files_S3_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S3_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s3_li1(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s3_li1(inputs)
	return ja_guide_large_json_files_s3_li1(inputs)
});